module.exports = __webpack_public_path__ + "d59942f58b67af887ea7e917c9fe825c.svg";